export class IntervalPrice {
  edited: boolean;
  intervalPriceId: number;
  conceptServiceId: number;
  intervalId: number;
  fromAmount: number;
  price: number;
  active: boolean;
}

export class UpdatedIntervalPrice {
  intervalPriceId: number;
  intervalId: number;
  fromAmount: number;
  price: number;
  active: boolean;
}
